import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['requests', 'services'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({ url: `${process.env.P2C_BASE_URI}/services` }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
      makeQueryParams: makeListRequest({}),
    })
  );

  store.dispatch('requests/services/initItems');
};
